import { Helmet } from "react-helmet";
import React, { Component } from "react";
import "../../styles/users/users.scss";
import { Button } from "react-bootstrap";
import ShowEntries from "../commoncomponents/ShowEntries";
import TemperatureAlertFilter from "../commoncomponents/TemperatureAlertFilter";
import Search from "../commoncomponents/Search";
import AssetTable from "./assetTable";
import { encodeQueryData } from "../../api/apiClient";
import axios from "axios";
import queryString from "query-string";
import { apiHost } from "../../api/apiClient";
import Paginations from "../commoncomponents/pagination";
import ShowingResults from "../commoncomponents/showingResults";
import Layout from "../../Layout/layout";
import { connect } from "react-redux";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";

class Assets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assetList: [],
      pageCount: 0,
      //states for showing entries and total entries in page
      totalEntry: 0,
      entryStart: "1",
      entryEnd: "50",
      totalFilter: false,
      totalEntryFilter: "",
      filterMessage: false,
      tempAlertFilter: "All",
      tempAlertEnabled: true,
      tempAlertDisabled: true,
    };
    this.searchText = "";
    this.customerId = "";
    this.pageSize = "50";
    this.pageKey = "1";
    this.sortDirection = "asc";
    this.sortString = "customer";
  }

  componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    var urlAll = "";
    if (values.customerId) {
      console.log("customerID", values.customerId);
      this.customerId = values.customerId;
      let query = encodeQueryData(this.setCustomersQueryObject());
      urlAll = `${apiHost}/api/Assets/AllAssets?${query}`;
      this.getAssets(urlAll);
    } else {
      let query = encodeQueryData(this.setCustomersQueryObject());
      urlAll = `${apiHost}/api/Assets/AllAssets?${query}`;
      this.getAssets(urlAll);
    }
  }

  getAssets = async (url) => {
    this.props.setLoadingPageAction(true);

    try {
      let assetList = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      // assetList.data.sort((a,b) => {
      //   if(a.customerName.toLowerCase() < b.customerName.toLowerCase()){
      //     return -1;
      //   }
      //   else if(a.customerName.toLowerCase() > b.customerName.toLowerCase()){
      //     return 1;
      //   }
      //   else if(a.name.toLowerCase() < b.name.toLowerCase()){
      //     return -1;
      //   } else if(a.name.toLowerCase() > b.name.toLowerCase()){
      //     return 1;
      //   } else{
      //     return 0;
      //   }
      // })
      this.setState({
        assetList: assetList.data,
        pageCount: JSON.parse(assetList.headers.pagination).totalPages,
      });
      this.handleShowResults(assetList);

      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);
      console.log(`😱 Axios request failed: ${e}`);
    }
  };
  handleSort = (name, order) => {
    this.sortString = name;
    this.sortDirection = order;
    console.log("name", this.sortString, "order", this.sortDirection);
    let query = encodeQueryData(this.setCustomersQueryObject());
    let urlAll = `${apiHost}/api/Assets/AllAssets?${query}`;
    this.getAssets(urlAll);
  };
  setCustomersQueryObject = () => {
    let data = {};
    data.SearchString = this.searchText;
    data.customerId = this.customerId;
    data.PageSize = this.pageSize;
    data.PageNumber = this.pageSize == 1000000 ? 1 : this.pageKey;
    data.SortDirection = this.sortDirection;
    data.SortString = this.customerId ? "name" : this.sortString;
    data.TempAlertFilter = this.state.tempAlertFilter;
    data.TempAlertEnabled = this.state.tempAlertEnabled;
    data.TempAlertDisabled = this.state.tempAlertDisabled;
    return data;
  };

  handlePagination = (page) => {
    this.pageKey = page;
    let query = encodeQueryData(this.setCustomersQueryObject());
    let urlAll = `${apiHost}/api/Assets/AllAssets?${query}`;
    this.getAssets(urlAll);
  };

  handleShowEntries = (inputShowEntries) => {
    this.pageSize = inputShowEntries;
    let query = encodeQueryData(this.setCustomersQueryObject());
    let urlAll = `${apiHost}/api/Assets/AllAssets?${query}`;
    this.getAssets(urlAll);
  };

  handleSearch = (inputSearch) => {
    //filtered by message on showing results
    if (inputSearch == "") {
      this.setState({ filterMessage: false });
    } else {
      this.setState({ filterMessage: true });
    }
    this.searchText = inputSearch;
    let query = encodeQueryData(this.setCustomersQueryObject());
    let urlAll = `${apiHost}/api/Assets/AllAssets?${query}`;
    this.getAssets(urlAll);
  };

  handleTempAlertFilter = (filterData) => {
    this.setState({
      tempAlertFilter: filterData.filterType,
      tempAlertEnabled: filterData.enabledChecked,
      tempAlertDisabled: filterData.disabledChecked
    }, () => {
      let query = encodeQueryData(this.setCustomersQueryObject());
      let urlAll = `${apiHost}/api/Assets/AllAssets?${query}`;
      this.getAssets(urlAll);
    });
  };
  handleShowResults = (response) => {
    // function for showing entries and total entries in page

    this.setState({
      totalEntry: JSON.parse(response.headers.pagination).totalItems,
    });
    if (!this.state.totalFilter) {
      this.setState({
        totalEntryFilter: JSON.parse(response.headers.pagination).totalItems,
        totalFilter: true,
      });
    }
    // debugger;
    this.setState({
      entryStart: parseInt(this.pageSize) == 1000000 ? 1 : (parseInt(this.pageKey) - 1) * parseInt(this.pageSize) + 1,
    });
    if (
      JSON.parse(response.headers.pagination).totalItems <
      parseInt(this.state.entryEnd)
    ) {
      this.setState({
        entryEnd: JSON.parse(response.headers.pagination).totalItems,
      });
    } else {
      let value =
        parseInt(JSON.parse(response.headers.pagination).currentPage) *
        parseInt(this.pageSize);
      this.setState({ entryEnd: value });
    }
    if (
      this.state.entryEnd >
      parseInt(JSON.parse(response.headers.pagination).totalItems)
    ) {
      this.setState({
        entryEnd: JSON.parse(response.headers.pagination).totalItems,
      });
    }
    if (this.state.assetList == "") {
      this.setState({ entryStart: "0", entryEnd: "0", totalEntry: "0" });
    }
  };

  handleCreateNew = () => {
    const values = queryString.parse(this.props.location.search);
    if (values.customerName) {
      this.props.history.push(
        `/createAsset?selectedAsset=${values.customerName}&customerId=${values.customerId}`
      );
    } else {
      this.props.history.push(`/createAsset`);
    }
  };

  render() {
    const arr = [50, 100, 150, 200, 1000000];
    const { assetList, pageCount } = this.state;
    const values = queryString.parse(this.props.location.search);
    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>All assets </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper">
              <h2>
                All assets
                {values.customerId && (
                  <small>
                    {`filtered by customerName `}
                    <a
                      onClick={() => localStorage.removeItem("customer")}
                      href="/assets"
                    >
                      <span>
                        <i className=" fa fa-times"></i>
                        {values.customerName}
                      </span>
                    </a>
                  </small>
                )}
              </h2>
              {localStorage.getItem('role') === "SystemAdmin" ?
                <Button variant="primary" onClick={() => this.handleCreateNew()}>
                  Create New
                </Button> : ''}

              <div className="inline">
                <ShowEntries
                  data={arr}
                  showEntriesCallback={this.handleShowEntries}
                />
                <TemperatureAlertFilter
                  onFilterChange={this.handleTempAlertFilter}
                />
                <Search searchCallback={this.handleSearch} />
              </div>
              <div className="userTable">
                <AssetTable assets={assetList} sortFunction={this.handleSort} />
              </div>
              <div className="paginationDetails">
                <ShowingResults
                  currentEntryStart={this.state.entryStart}
                  currentEntryEnd={this.state.entryEnd}
                  totalEntries={this.state.totalEntry}
                  totalFilterEntries={this.state.totalEntryFilter}
                  filterMessage={this.state.filterMessage}
                />
                <Paginations
                  pageCount={pageCount}
                  pageRange={5}
                  onPagination={this.handlePagination}
                ></Paginations>
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  customerName: state.customerName,

  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Assets);
